import React from "react"

import Layout from "../components/layout"
import DynamicComponent from "../components/dynamic-component"
import { getDynamicSeoData } from "../utils/helpers"
import Seo from "../components/seo"

export const Head = ({ location, pageContext }) => {
  const { data } = pageContext ?? {}
  const { extraMetaData } = data?.attributes ?? {}

  return (
    <Seo
      extraMetaData={extraMetaData}
      seoData={getDynamicSeoData(pageContext.data)}
      pathname={location?.pathname}
    />
  )
}

const Page = ({ location, pageContext }) => {
  // eslint-disable-next-line no-unused-vars
  const [none, lang, site, pageName] = location.pathname.split("/")
  const routeParams = {
    location: `${lang}/${site}`,
    page: pageName,
  }

  const page = pageContext?.data ?? {}

  return (
    <Layout routeParams={routeParams} location={location}>
      {page.attributes.Components.map((component, index) => {
        return (
          <DynamicComponent
            component={component}
            key={`${index}-component`}
            params={routeParams}
          />
        )
      })}
    </Layout>
  )
}

export default Page
